export default __webpack_public_path__ + "static/media/img6.6c2accb7.jpg";